import React from 'react';
import { Table, Typography } from 'antd';
import { useRepresentative } from '@hooks/RepresentativeContext';
import TableFilters from '../../../../components/TableFilters';
import { SearchOutlined } from '@ant-design/icons';

const { Title } = Typography;
interface CustomersProps {}

const Customers: React.FC<CustomersProps> = () => {
  const { customers, customersTotal } = useRepresentative();

  const columns = [
    {
      title: 'Código',
      width: '100px',
      align: 'center' as 'center',
      dataIndex: 'code',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pelo Código'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.code ? record.code.toString().toLowerCase().includes(value.toLowerCase()) : false;
      },
      sorter: (clienteA: any, clienteB: any) => clienteA.code - clienteB.code,
    },
    {
      title: 'Lojista',
      dataIndex: 'name',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pelo Lojista'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.name ? record.name.toString().toLowerCase().includes(value.toLowerCase()) : false;
      },
      sorter: (clienteA: any, clienteB: any) => clienteA.name.trim().localeCompare(clienteB.name.trim()),
    },
  ];

  return (
    <div className="mt-6 ml-4">
      <Title level={5}>Carteira de Clientes</Title>
      <Table
        columns={columns}
        dataSource={customers}
        rowKey={(record) => record.code}
        scroll={{ x: 800 }}
        pagination={{
          pageSize: 8,
          total: customersTotal,
          showSizeChanger: false,
          showQuickJumper: false,
        }}
      />
    </div>
  );
};

export default Customers;
